<template>
  <div class="content_box row-center-wrapper acea-row row-column">
    <div
      :style="`backgroundImage: url(` + topHeaderImg + `)`"
      class="header_box row-column acea-row row-center-wrapper"
    >
      <div class="item">新闻资讯</div>
      <div class="item_small">-NEWS INFORMATION-</div>
    </div>
    <div class="title">{{ currentItem.title }}</div>
    <div class="fabutime">发布时间：{{currentItem.time}}</div>
    <div class="neirong">{{currentItem.content}}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentItem: {},
      newsList: [
        {
          image: require("@/assets/main/news/NewsImage2.png"),
          title: "电镀行业警钟鸣 污水治理要先行",
          time: "2020-09-17",
          content: `

电镀行业，是我国平面处理行业中一个主要的引导产业，同样中国也是世界的电镀大国，产业的发展离不开企业的支持，企业的发展离不开群众的支持。电镀的生产工艺中，需要用到大量的化学原料和水资源，就在生产工艺的背后，一个一直困扰不少人和企业的问题-“污水治理”，一直很让人揪心，国家不断的强化污水的治理法规，有的企业在配合国家的政策，但是有的企业却抱以“道高一尺，魔高一丈”的心态，不断钻法律的空子，想方设法的偷排污水，给国家和人民群众的生活带来了不小的灾害。

偷排的污水直接灌入农田

触目惊心的画面

环境保护，污水治理的问题，已经是一个跟我们生活息息相关的话题了，有不少国内的企业以身作则，花了大笔的资金对生产污水进行处理，有始有终才可以让一个企业更好的发展，如果一个企业只是一味的挣钱发展，而对于生产背后的垃圾置之不理，最后导致残害民生的话，等待这个企业的不仅仅是法律的制裁，更多的是人们群众的指责。作为一个世界上的电镀大国，如果我们不为电镀行业污水治理开一个好头，无论电镀行业在中国如何发展，相比欧美国家都会有一定差距，技术的差距可以克服，但是污染的治理我们应该如何克服呢。

措施一：整治小电镀等重污染企业取缔水源保护区一切排污口

近年来，各地纷纷加强电镀等企业污染整治，各地环保专项行动层出不穷。据悉，哈尔滨将进一步加强松花江流域电镀污染治理；淡水河流域内所有电镀企业整合入园；2013年年底前，花都将关闭或转移区内所有电镀企业；中山市编制电镀等重污染行业统一规划、统一定点实施方案；自2007年以来，惠阳和大亚湾在淡水河流域共限期治理企业36家，关停企业22家；银川市年内将对国家限期淘汰落后产能和已明令淘汰的小炼铁、小电镀、小造纸等高能耗企业全面清查拆除。

污水处理设施

措施二：加快产业结构和布局调整,推进清洁生产，提升工业污染防治水

电镀污水处理中心的兴建也为电镀企业降低污染，清洁生产走出了一条示范的道路。鄱阳县在全省县一级工业园区率先建成电镀污水处理中心，淘汰了９个污染企业和６条落后生产线，万元生产总值综合能耗下降４％，化学需氧量和二氧化硫排放量分别下降４．５％和１１．３％；南安的新电镀集控中心也是个典型的循环经济项目，其中，电镀污水处理能力可达到8600吨/日。这些污水经国内最先进的污水处理技术——膜处理后，回收用水将达60%以上，每年减排电镀废水量达200万吨；集控中心每年还可回收金属镍50至60吨、铜100至120吨及部分六价铬、锌等重金属，回收价值高达1000多万元。

措施三：排污权有偿使用

最近，排污权的有偿使用也成了电镀企业关注的热点。江阴电镀等水污染企申购排污权热情不减。江阴市化工、钢铁、电镀、及其他生产经营过程中直接或间接经许可向环境排放化学需氧量的排污单位和全市经许可向环境排放二氧化硫的排污单位，都纳入了排污权有偿使用的范围。

具体收费标准是:排入集中式污水处理厂进行处理的排污单位，化学需氧量排放指标有偿使用收费标准为2600元/年·吨；直接向环境排放污染物的排污单位，化学需氧量有偿使用收费标准是4500元/年·吨。

污水处理设施

措施四：加快推动环保电镀园区的建设

据悉：惠州市正在大力推动电镀园区的建设，将通过电镀行业的整合入园来全面清理整顿淡水河流域内所有电镀企业，目前，惠阳区政府已基本完成电镀园区选址工作，将于2010年底前按规定完成园区建设任务；广东阳江市政府要求当地的五金电镀企业于二0一0年年底完统一迁至市郊的环保工业城。目前，该环保工业城日处理污水量五千吨的污水处理厂首期主体工程已经完工；为保护泉州的“母亲河”晋江，南安仑苍电镀集控区正在加快异地搬迁步伐。从相关部门获悉，目前，新的电镀集控中心已完成投资1.98亿元，一期大部分安置厂房已封顶，污水处理厂工程将于6月底完工并进入调试运行。
`,
        },
        {
          image: require("@/assets/main/news/NewsImage3.png"),
          title: "全球安防产品出厂或达2340亿美元",
          time: "2020-09-17",
          content: `
相关数据统计显示，从2008年至今，全球电子安防市场以年均4.5%的增长率不断增长，成为全球经济不景气状况下的一抹亮色。据Memoori公司预测，2013年全球安防产品出厂总价值将高达2340亿美元，而且，在未来五年将保持8%的年均增长率，在2017年，将达到3220亿美元。

亚洲高端安防市场的需求已经成为全球电子安防市场增长的重要动力，到目前为止，占物理安全领域的份额已达39%，而欧洲、斯堪的纳维亚半岛和北美等发达市场虽然仍占总业务量的47%，却比去年减少了两个百分点。

不过，即便如此，中国物理安全产品的渗透率仍只有北美地区的1/6，在2013年，安防产品人均销售额仅为3.34美元，仍存在较大的增长空间。
`,
        },
        {
          image: require("@/assets/main/news/NewsImage4.png"),
          title: "解析中小企业安防市场现状及趋势",
          time: "2020-09-17",
          content: `国内安防中小企业“四面楚歌”

　　近年来，由于受到物价与原材料价格普遍上涨、人民币大幅升值、消费需求减弱、劳动力成本攀升及货币政策紧缩等诸多因素的影响，为数不少的中小企业已频临倒闭边缘：企业订单少、招工难、资金回笼慢、融资难。在国内安防企业中，中小型企业占绝大多数，毫无疑问也同样面临着同样的问题，据了解，受市场疲软的影响，国内部分中小安防企业已经接近“四面楚歌”的生存绝境。

　　转型：具备产业链资源整合能力

　　转型难：微利时代背景下安防中小企业现状中国安防行业历经30余年发展，市场已基本进入成熟阶段。随着各项新政策的不断出台，国家逐步加大对集团化、规模化、集约化大中型企业的整合力度，同时，传统行业如电子、生物等安防相关领域的龙头企业也渐渐卷入安防行业发展的大潮中。在这样双重夹击的背景下，中小型安防企业要想找到自己的生存法则，必须及早实现转型。

　　随着物联网技术的应用推广，网络化、高清化、智能化技术的不断成熟，安防企业已经不能再单一地定位于订单接洽、产品研发制造及销售服务环节了，而应注意整合安防企业上、中、下游的产业链资源，因为未来企业的竞争已不是企业规模、产能及产品的竞争，而是取决于企业能否具备产业链资源整合的核心能力。转型早、转型快、转型准的安防企业，相信已经尝到不少甜头，而目前仍然停留在传统手工作坊式、按订单生产等方式的企业必定会面临生存的困难。国内安防行业人力成本及营销成本节节攀升，产品价格却始终处于低端或低空区域;中小企业仍处于规模小、区域分布不均、综合竞争力不足及投融资渠道不够畅通的劣势，这些综合因素进一步加剧了安防中小企业转型难的困境。

　　市场风波带来毁灭性打击

　　2011年上半年，由于日本大地震的强烈冲击，一场前所未有电子产品提价风波影响全球。安防行业更是深受其害，由于传感器等核心部件由于多数为国外进口，所以随之涨价也是必然。同时，2011年DVR的大范围降价在整个安防行业可谓一石激起千层浪，引发了不少的震荡，受其直接影响的中小企业更似“惊弓之鸟”。市场竞争往往是现实的，也是残酷的，一波未平、一波又起，每一段市场风波，对身处艰难处境的中小安防企业来说，或许都是一次毁灭性的打击。

　　外资巨头和国内大企中夹缝生存

　　在这样的背景之下，有实力、有规模、资金流畅通的大中型安防企业可通过资源整合、产业升级、产品转型实现新的利润增长，保证企业的领先优势，但占安防行业绝大多数的中小企业却因规模小、综合实力弱、抗风险能力小等因素的局限，无法顺利或短时间内实现产业升级和转型，面对海内外市场的风云变幻，这些中小企业无论是资源、品牌还是在综合竞争力上均没有任何优势，随着人民币汇率波动的又一层打击，也让原本对价格优势抱有一丝幻想的中小企业濒临死亡边缘。人民币的升值将导致国内外安防产品竞争加剧，中小型安防企业只能选择在外资巨头和国内大规模集团化企业的夹缝中生存，由此可见，中国安防中小企业的生存空间和转型之路已变得越来越狭窄。

　　如何转“危”为“机”?

　　度危机：冷静应对，理性分析危机四伏更待柳暗花明，如何转“危”为“机”、谋求发展新出路，成为中小型安防企业面临并亟需解决的一个严肃而重要的课题。即使当前的市场环境恶劣复杂，我们仍能欣喜地看到，在困难中众多中小安防企业依然不断突破局限，努力坚持，改变生存法则。再大的企业也是从小企业开始做起来，无论前面的道路有多么艰难，安防中小企业都应该冷静分析，沉着应对，审时度势，寻求适合自己的生存之道。只有这样，企业才能存活下去，才能有健康长远的发展。中小企业依然占绝大多数，这是中国安防行业的现状也是安防企业的特性，对此我们不应只看到自己的劣势，同时也应看到自己的优势——麻雀虽小，五脏俱全。

　　作为企业的决策者及掌舵人，企业家更应摸清市场发展规律，顺应复杂外部环境，及时了解国家政策导向，在多变的市场竞争中寻求企业发展的新机遇。企业技术研发的新突破，产学研资源的充分整合，产品的转型升级，社会公共环境的市场需求及更为广泛的民用市场需求，都是安防企业可以努力去尝试并开拓的新蓝海。

　　民用安防带来生机

　　随时安防民用化的程度越来越高，安防产品走入寻常百姓家已成为不争的事实，如何抓住这个千载难逢的机遇，推动安防产品民用化，将成为安防中小企业实现跨越式发展的绝佳途径。如此说来，国内的安防企业特别是中小型安防企业只有夯实基础、打牢基本功，保持客观冷静心态，针对社会市场尤其是民用市场做多角度、深层次的分析，让自己的产品在竞争中占据更多的市场份额，为企业争取新的生存空间，除此以外，别无他途。求突围：转换思路，实现重生现代企业的竞争已经不再局限于传统意义上的产品、价格、渠道及市场等方面的竞争，而更多取决于新商业模式的竞争。

　　互联网、物联网引领新市场革命带来挑战和商机

　　随着互联网、物联网技术的不断成熟和应用推广，未来安防行业市场的竞争将不再是实体社会中的较量，而更多是在遍及全球的网络中进行。产品同质化、商业模式单一化将会使更多的安防中小企业面临生存发展的严峻挑战。终端客户消费习惯向互联网方向转变已渐成趋势，对此中小安防企业不应再聚集在单一营销层面，而应拓展多重营销模式，实现在新环境、新市场下的全面突围。随着信息技术的高速发展，拓展网络平台、实现新概念营销是企业生存发展的必经之路。互联网、物联网技术的综合应用推陈出新，必将引领一场新的市场革命，在这股浪潮的冲击下，国内安防中小企业能否抓住网络时代的发展机遇，创新营销模式，已成为企业发展转型的关键任务之一。令人担忧的是，目前国内大多数安防企业，无论是大型企业还是中小型企业均对互联网营销存有不同程度的陌生感与疑虑，对新商业模式不认同、不了解，对互联网、物联网等新平台不甚明白、无法接纳，甚至是一无所知。

　　“互联网”和“物联网”平台影响中小企业未来走向

　　中小安防企业如何牢牢掌握“互联网”和“物联网”两大创新平台，实现新营销模式的突破和创新，将直接影响中小安防企业未来的发展走向。观未来：开拓新兴市场是关键据行业统计数据显示，2010年我国安防行业产值将达到2270亿元的规模，北京奥运会、广州亚运会、上海世博会以及深圳大运会，都已经或即将进一步催生安防产业新的、更大的市场空间，也让安防产品的应用逐步拓展到更广泛的领域，被人们熟知或关注。

　　安防行业相关领域的高速发展，高科技、绿色节能模式的大范围推广和应用，以及高科技、多元化、数字化、集成化尖端产品的不断涌现，这一切都加速了安防市场的蓬勃发展。今天的中国，已俨然成为世界上最具规模、最具潜力和影响力的安防新兴市场，“中国制造”正向“中国创造”大踏步跨越，安防行业正进一步得到国家、社会和民众的高度重视，并成为国民经济新的经济增长点和战略性新兴产业之一。随着中央及地方各级政府对新兴产业的大力扶持，安防及相关产业中下游需求的强势拉动，安防产业综合竞争力的不断提升，社会民众消费能力以及安防意识的不断增强，国内安防产业也将从中受益。特别是在智能交通、教育、建筑、水利、医疗等多个领域，安防的重要性正得到更广泛的重视和关注，而网络、智能、高清等发展趋势则对安防企业提出了更高的要求。

　　总结

　　安防行业经过多年的市场培育和推广，在金融、公安、交通等传统行业已得到普遍性应用，建筑、电力、矿山、港口、教育及医疗等新兴安防应用行业对安防产品需求也呈快速增长趋势，而与此同时，随着百姓生活水平的提高，人们消费水平和结构发生了较大的变化，人们的自我保护和安全防范意识也有所改变，这也使得安防产品得到更广泛的应用。

来源：安防知识网`,
        },
        {
          image: require("@/assets/main/news/NewsImage1.png"),
          title: "物联网大发展将带动实体经济大发展",
          time: "2023-07-07",
          content:
          `党的二十大报告提出，加快发展数字经济，促进数字经济和实体经济深度融合，打造具有国际竞争力的数字产业集群。以新一代信息通信技术为主要手段的物联网，作为新型基础设施的重要组成部分已深入千行百业，正在为数字经济发展注入强劲动力。

在7月3日举行的“2023世界物联网500强峰会”上，伴随着2023世界物联网500强排行榜的对外发布，物联网与数字经济关系、市场构建、产业体系发展的重要性等话题亦成为与会委员、专家热议的焦点。

成绩斐然助力数字经济繁荣

近年来，我国物联网基础设施建设扎实推进，产业发展良好，融合应用百花齐放、硕果累累。

在基础设施建设与产业发展方面，窄带物联网、4G5G与固定宽带协同发展，基本实现城乡普遍覆盖和重点场景深度覆盖。在融合应用实践方面，国内各类企业依托网络创新应用、物联网操作系统、物联网平台等技术（服务），探索工业互联、智慧农业(3.410, -0.08, -2.29%)、智能家居等应用新模式，变革生产和生活方式，成效显著。`,
        },
        {
          image: require("@/assets/main/news/NewsImage4.png"),
          title: "物联网在智能开关领域的应用场景及行业痛点",
          time: "2022-10-01",
          content:
          `随着4G广泛应用，5G快速推进，以NB-IoT、eMTC等为代表的新一代物联网技术顺势而生。当前，物与物连接规模急剧扩张，连接应用日新月异，物联网技术可以说已深度嵌入多个垂直行业，广泛应用于以下等重要领域：

一．工业能源：涵盖智能抄表、智能开关、产品全流程管理等；

二．交通行业：涵盖智能泊车、共享单车等；

三．智能家居；

四．远程健康管理；

五．智慧城市：涵盖智能路灯、空气检测、智能井盖等；

六．智慧农业：涵盖智慧大棚、动物溯源、林业数据采集等；

七．金融行业：融资租赁、款箱监控等；

八．其他

由于物联网技术正在深度渗透社会各个行业，所以在不同领域物联网技术应用也面对着情况不一的行业痛点。对此，通信世界网将逐一进行解读剖析。上次，笔者撰写的《物联网在智能抄表领域的应用场景及行业痛点》收到大量读者反馈及部分物联网垂直媒体转载，起到了一定交流价值。本次进行解读的将围绕智能开关，论述其在物联网应用场景及行业痛点。

目前，物联网在智能开关领域的主要应用场景多表现在：偷漏油事件监控、厂区/仓库管理等方面。

偷漏油事件监控

众所周知，油品运输车辆需要长途行驶，输油管道大量分布在人迹罕至区域，容易受到“油耗子”的偷油威胁，或因长年使用造成破损，带来偷漏油问题。

智能开关如果通过在油罐车出油口、油路管线重要节点等处设置，便能实现对取油过程的精准管理。因为只有获得授权的工作人员才能打开开关，如目的地油气站工作人员、加油站操作员、管线维护工。

目前，智能开关企业在物联网应用方面多倾向于使用NB-IoT网络，通过其自动上报每一次的开闭信息。例如，中国移动推出的智能开关解决方案，当非授权人员试图打开油路开关、暴力破拆、钻眼打洞时，智能开关将自动锁死，生成告警信息和异常记录，上报平台，并同步触发本地的警笛、灯光等联动告警装置。

当然，只是单纯的本地告警还是不够的，还需要平台下发告警信息到油料管理员的手持终端上，并能记录异常事件日志，为后续处理提供帮助。通过以上双重告警机制，来提高违法行为的难度。

厂区/仓库管理

工业厂房一般占地面积较大，距离城市远，厂房内部放置了大量核心资产，企业一般会安排多名管理员管理门禁。因此，无论是开门、锁门，还是日常的人员和车辆进出管理，都比较辛苦，人工成本高，且存在一定安全隐患。

子场景1：对于智能开关需求，一般需满足厂房管理员借助手持终端，通过远程遥控方式，进行大门开锁或者解锁。并且，智能开关平台的管理员可以通过设置用户角色，为厂房管理员分配开锁和解锁权限，进行权限的分散和轮转，能够实现厂区大门管理从传统的“管钥匙”向“管权限”的升级。此外，还要求智能开关平台可与巡检平台进行对接，实现定期厂区库房的巡检；

子场景2：当部署在厂区大门上的智能锁具检测到外部撞击、异常震动、暴利破拆时，可以通过网络自动发送告警信息至业务平台，并下发至厂房管理员，管理员据此采取相应措施；

子场景3：对于智能开关管理平台，管理员可以设置智能锁具与指定车辆进行匹配，通过短距离短信或视频监控进行车辆识别，识别成功则智能锁具自动打开或关闭，并将进出记录自动回传至平台，进而能够起到减轻由厂房管理员带钥匙频繁来现场打开和锁闭大门的工作量的作用。

除此之外，业界对于智能开关应用需求还有以下几种场景，例如：箱柜安全保护：提供自动开锁解锁、异常告警等功能。文件柜管理员或箱体持有人通过手机APP扫码等方式，设置智能锁具的上锁或者解锁，及时获知暴力破解信息，有效降低文件或行李丢失的几率；

室内门禁管理：对机房、档案室等重要区域提供门禁管理、资源管理、设备守护等功能。区域管理人员可通过业务平台门户或者手机APP，直接控制各个门禁的开闭，或者设置门禁的进出方式，进行各扇门的开闭授权，实现对区域的统一管理；

光交换箱管理：提供对交换箱的状态监测、异常情况告警、记录开闭日志等功能。运维人员通过手机APP，可随时查看光交换箱门锁的状态，记录设备正常维护带来的箱门开闭信息。当箱体遇到人为破坏或者意外撞击时，运维人员及时获取异常告警，联系人员赴现场处置。

智能开关领域行业痛点

传统的开关产品使用方式包括人为配备钥匙、安排巡逻人员、加大锁具本身的牢固程度、设置视频监控探头等。目前，这些方式普遍面临着钥匙管控难、状态无监控、巡检管理难、人力成本高、需事后处置等诸多问题，亟待引入更高效的解决方法。

其中，在工业品存储运输过程中，传统锁具不具备开锁人员识别及远程控制、定位等功能，监督主要靠人员交接，导致不法人员偷盗、破坏、监守自盗等事件时有发生，给企业带来经济损失。如某油田每年因原油被盗，损失超过1亿元；某省曾发生一起运输司机偷换油品事件，造成100辆运油车出现故障，经济损失超过1000万元。

智能开关应用前景广阔

开关产品用来对被控对象的状态进行管理和控制，体现授权用户对被控对象的查看、使用、处置等权利。授权形式可以是钥匙、账号、专用设备、生物特征等。开关产品形态千差万别，例如汽车锁、门锁、集装箱锁、快递包裹、输油管道阀口、门店封条等。因此，开关产品在工业、能源、市政、电信等众多行业具有广泛的应用需求。

目前，包括中国移动、小为、开源智能、爱普瑞等在内的企业已经推出多种智能开关解决方案。例如，中国移动借助NB-IoT技术具有低功耗、低成本、支持海量连接、适用于小数据量和非移动性业务等特点，开发出的智能开关解决方案融合了智能锁具、业务管理平台、行业终端等智能化设备，为大门、阀门、箱柜等具有开关特性的产品提供门禁管理、状态监测、异常告警等综合性用户服务。

由于工业能源企业多数为重资产型企业，需要投入庞大的人力物力来实现资产管理。目前，涉及智能开关领域的物联网企业主要涵盖芯片/模组厂商、智能硬件厂商与第三方应用提供商。`,
        },
      ],
      topHeaderImg: require("@/assets/main/news/newsBg1.png"),
    };
  },
  created: function () {
    console.log("打印取值的结果", this.$route.query.title);
    if (
      this.$route.query.title != undefined &&
      this.$route.query.title != null &&
      this.$route.query.title != ""
    ) {
      for (let item of this.newsList) {
        if (item.title == this.$route.query.title) {
          this.currentItem = item;
        }
      }
    }
  },
};
</script>
<style scoped>
.content_box .title {
  color: #515254;
  font-size: 40px;
  font-weight: bolder;
  margin-top: 4%;
}
.content_box .fabutime{
    color: #888;
    font-size: 20px;
    margin-top: 20px;
}
.content_box .neirong{
    color: rgb(51, 51, 51);
    font-size: 23px;
    margin-top: 40px;
    width: 60%;
    line-height: 70px;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
.content_box .newList_content {
  padding: 20px 0px;
  width: 100%;
}
/* 关于我们 begin */
</style>



// WEBPACK FOOTER //
// src/views/newList/edit.vue